<template>
    <div class="hv-opener">
        <div class="modal fade" :id="'questionmodal'+questionId" ref="questionModal" tabindex="-1" role="dialog" :aria-labelledby="'questionmodal'+questionId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="t3" style="color: #c00">{{ getTrans("HeaderName") }}</div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <p>
                                    {{ getTrans("BodyText1")  }}
                                </p>
                                <p>
                                    {{ getTrans("BodyContactInformation") }}
                                </p>
                                <p>
                                    {{ getTrans("BodyText2") }}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                
                                <form>
                                    <div class="form-group">
                                        <label :for="'inputArticleId'+questionId">{{ getTrans("FormNameArtikelID") }}</label>
                                        <input type="text" class="form-control" :id="'inputArticleId'+questionId" :placeholder="getTrans('FormNameArtikelID')" :value="itemId" readonly>
                                    </div>
                                    <div class="form-group">
                                        <label :for="'inputArticleNumber'+questionId">{{ getTrans("FormNameArtikelnummer") }}</label>
                                        <input type="text" class="form-control" :id="'inputArticleNumber'+questionId" :placeholder="getTrans('FormNameArtikelnummer')" :value="variationNumber" readonly>
                                    </div>
                                    <div class="form-group">
                                        <label :for="'inputName'+questionId">{{ getTrans("FormNameName") }}</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': inputName && inputName.length == 0 }" :id="'inputName'+questionId" v-model="inputName" :placeholder="getTrans('FormLabelName')" >
                                    </div>
                                    <div class="form-group" v-if="questionId == 1" >
                                        <label :for="'currentprice'+questionId">{{ getTrans("FormNameAktuellerPreis") }}</label>
                                        <input type="text" class="form-control" :id="'currentprice'+questionId" :value="defaultPrice" readonly>
                                    </div>
                                    <div class="form-group" v-if="questionId == 1" >
                                        <label :for="'inputPrice'+questionId">{{ getTrans("FormNameIhrePreisanfrage") }}</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': inputPrice && inputPrice.length == 0 }" :id="'inputPrice'+questionId" v-model="inputPrice" :placeholder="getTrans('FormLabelIhrePreisanfrage')">
                                    </div>
                                    
                                    <div class="form-group">
                                        <label :for="'inputEmail'+questionId">{{ getTrans("FormNameEmailAdresse") }}</label>
                                        <input type="email" class="form-control" :class="{ 'is-invalid': inputEmail && inputEmail.length == 0 }" :id="'inputEmail'+questionId" v-model="inputEmail" aria-describedby="emailHelp" :placeholder="getTrans('FormLabelEmailAdresse')">
                                    </div>

                                    <div class="form-group">
                                        <label :for="'inputComment'+questionId">{{ questionId == 1 ? getTrans("FormNameComment") : getTrans("FormIhreFrage") }}</label>
                                        <textarea class="form-control" :id="'inputComment'+questionId" v-model="inputComment" :placeholder="questionId == 1 ? getTrans('FormLabelComment') : getTrans('FormLabelIhreFrage')" height="400px"></textarea>
                                    </div>

                                    <input type="hidden" :id="'referrerId'+questionId" name="referrerId" :value="referrerId" >
                                    <input type="button" :id="'sendNewPrice'+questionId" class="btn btn-primary" :value="getTrans('FormSubmitButton')" @click="sendPrice" v-if="!isOnSending" >
                                </form>

                                <div :id="'question-alert'+questionId" class="alert alert-success mt-2" role="alert" v-if="isAlertOpen" >
                                    {{ getTrans("FormSuccessAlert")  }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../app/services/ApiService";
import NotificationService from "../../app/services/NotificationService";
import { mapGetters } from "vuex";

export default {
    name: "article-questions",
    props:
    {
        questionId:
        {
            type: Number,
            default: 1
        }
    },
    inject: {
        itemId: {
            default: null
        }
    },
    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },
        variationNumber() {
            return this.currentVariation.variation.number;
        },
        defaultPrice() {
            return this.currentVariation.prices.default.price.value;
        },
        referrerId() {
            return this.$store.state.basket.data.referrerId;
        },
        ...mapGetters([
            "getCountryName"
        ])
    },
    created()
    { 
        if(this.questionId == 1) {
            this.translateText = "priceRequest";
        } else {
            this.translateText = "questionItem";
        }
    },
    data() {
      return {
        isAlertOpen: false,
        translateText: "priceRequest",
        isOnSending: false,
        inputName: "",
        inputPrice: "",
        inputEmail:"",
        inputComment: ""
      };
    },
    methods: {
        getTrans(text) {
            let textId = "ZeitloungeTheme::Template." + this.translateText + text;
            return this.$translate(textId);
        },
        openModal() {
           this.isAlertOpen = false;
        },
        closeModal() {
            $(this.$refs.questionModal).modal('hide');
        },
        sendPrice() {

            var type = this.questionId == 1 ? 'pricerequest' : 'question';
            var language = App.language ?  App.language : '';
            var lang = language;
            language = this.getCountryName(language);

            var dataObj = {
                'articlenumber': this.variationNumber,
                'articleid': this.itemId,
                'name': this.inputName,
                'email': this.inputEmail,
                'type': type,
                'language': language,
                'lang': lang,
                'currency': App.activeCurrency ?  App.activeCurrency : ''
            };

            if (dataObj.currency === '£') {
                dataObj.currency = "GBP";
            } else if(dataObj.currency === '€') {
                dataObj.currency = "EUR";
            }

            if(this.questionId == 1) {
                dataObj.price = this.inputPrice;
                dataObj.currentprice = this.defaultPrice;
                dataObj.comment = this.inputComment;
            } else {
                dataObj.question = this.inputComment;
            }


            if(!this.validateForm(dataObj)){
                return false;
            }
 

            this.isOnSending = true;
            setTimeout(() => { 
                this.closeModal();
            }, 1000);

            let ref = this.referrerId;
            ref = ref ? ref : "none";

            if(this.questionId == 1){
                ga('send', 'event', 'Preisanfrage', 'send', 'Sprache: '+lang+', ReferrerId: '+ref);
            } else {
                ga('send', 'event', 'Frage zum Artikel', 'send', 'Sprache: '+lang+', ReferrerId: '+ref);
            }


            ApiService.post("/preisanfragemail", dataObj)
                .done(data =>
                {

                    NotificationService.success(
                        this.getTrans("FormSuccessAlert")
                    ).closeAfter(3000);
                })
                .fail(() =>
                {
                    NotificationService.error(
                        this.getTrans("FormErrorAlert")
                    ).closeAfter(5000);
                })
                .always(() =>
                {
                    
                });
                return false;
        },
        validateForm(dataObj) {

            this.resetInvalidRedMarks();
            var valid = true;

            if(!dataObj.articlenumber || dataObj.articlenumber.length == 0){
                $('#inputArticleNumber'+this.questionId).addClass('is-invalid');
                valid = false;
            }
            if(!dataObj.articleid || dataObj.articleid.length == 0){
                $('#inputArticleId'+this.questionId).addClass('is-invalid');
                valid = false;
            }
            if(!dataObj.name || dataObj.name.length == 0){
                $('#inputName'+this.questionId).addClass('is-invalid');
                valid = false;
            }
            
            if(this.questionId == 1) {
                if(!dataObj.price || dataObj.price.length == 0){
                    $('#inputPrice'+this.questionId).addClass('is-invalid');
                    valid = false;
                }   
            } else {
                if(!dataObj.question || dataObj.question.length == 0){
                    $('#inputComment'+this.questionId).addClass('is-invalid');
                    valid = false;
                }
            }
            
            var emailValidRegex = /\S+@\S+\.\S+/;

            if(!dataObj.email || !emailValidRegex.test(dataObj.email)){
                $('#inputEmail'+this.questionId).addClass('is-invalid');
                valid = false;
            }

            return valid;
        },
        resetInvalidRedMarks() { 
            $('#inputArticleId'+this.questionId).removeClass('is-invalid');
            $('#inputArticleNumber'+this.questionId).removeClass('is-invalid');
            $('#inputPrice'+this.questionId).removeClass('is-invalid');
            $('#inputName'+this.questionId).removeClass('is-invalid');
        }
    }
}
</script>
